module.exports = {
      id: "linkedin-usage",
      viewBox: "0 0 12 12",
      url: "/" + "sprite-0c9f646beffa24bb04e01488ef4c0ff4.svg#linkedin",
      toString: function () {
        return this.url;
      }
    }